import "three/examples/js/objects/Reflector";

export default class Spiegel extends THREE.Reflector {

    constructor(vsData, brett) {
        /* super(brett.getFrontGeometry(), {
            clipBias: 0.003,
            textureWidth: window.innerWidth * window.devicePixelRatio,
            textureHeight: window.innerHeight * window.devicePixelRatio,
            color: 0x889999,
            recursion: 0,
            envMap: APP.model.raum.envmap
        }); */
        super(
            brett.getFrontGeometry(),
            {
                textureWidth: window.innerWidth * window.devicePixelRatio,
                textureHeight: window.innerHeight * window.devicePixelRatio,
                recursion: 1,
                color: 0x889999
            })
        this.vsData = vsData;
        this.brett = brett;

        /* new THREE.MeshBasicMaterial( { color: 0xFFFFFF, envMap: APP.model.raum.envmap } ); */
    }

    vsUpdate() {
        const verticesChanged = this.brett.object3d.isVsChanged('vertices');
        if (verticesChanged) {
            this.updateGeometry();
        }
    }

    updateGeometry() {
        this.geometry = this.brett.getFrontGeometry();
        this.position.z = this.brett.box.max.z + APP.settings.getFloat('spiegel_offset', 0.5);
    }
}
